module.exports = __webpack_public_path__ + "static/media/noon-now-ar.9e525d01.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/noon-now-ar.svg
// module id = 853
// module chunks = 2